<!-- NAVBAR -->
<app-navbar-panel
  class="fixed inset-x-0 top-0 h-[var(--navbar-height,64px)] z-50">
</app-navbar-panel>

<!-- SIDEBAR -->
<app-sidebar
  (selectedItem)="mostrarItemSelecionado($event)"
  (menuStatus)="setStatusMenu($event)"
  class="fixed left-0 top-[var(--navbar-height,64px)]
         h-[calc(100vh-var(--navbar-height,64px))] z-40
         w-[var(--sidebar-width,90px)]
         transition-[width] duration-300 ease-in-out">
</app-sidebar>

<!-- CONTEÚDO -->
<div
  class="min-h-screen
         pt-[var(--navbar-height,64px)]
         pl-[var(--sidebar-width,90px)]
         transition-[padding] duration-300 ease-in-out">

  <section class="px-4 md:px-8">
    <ng-container *ngIf="itemSelecionado === 'clientes'">
      <app-clientes></app-clientes>
    </ng-container>
    <ng-container *ngIf="itemSelecionado === 'licencas'">
      <app-licencas></app-licencas>
    </ng-container>
    <ng-container *ngIf="itemSelecionado === 'webhooks'">
      <app-webhooks></app-webhooks>
    </ng-container>
    <ng-container *ngIf="itemSelecionado === 'configuracoes'">
      <app-configuracoes></app-configuracoes>
    </ng-container>
    <ng-container *ngIf="itemSelecionado === 'revendedores'">
      <app-revendedores></app-revendedores>
    </ng-container>
  </section>
</div>